import { parseAsInteger, useQueryState } from 'nuqs';
import { useDeferredValue, useMemo } from 'react';
import { defaultSorting } from '@/features/purchase-planning/hooks/use-purchase-planning-table';
import { usePurchasePlanningWeek } from '@/features/purchase-planning/hooks/use-purchase-planning-week';
import { getSortingStateParser } from '@/lib/parsers';
import { useGetPurchasePlanning } from '@/services/apis/queries/purchase-planning/use-get-purchase-planning';
import type { PurchasePlanning } from '@/types/core/purchase-planning/purchase-planning';
import { usePurchasePlanningFilters } from './use-purchase-planning-filters';

export const usePurchasePlanningQuery = () => {
  const { weekParams } = usePurchasePlanningWeek();
  const { year, week, endYear, endWeek } = weekParams;
  const [page] = useQueryState('page', parseAsInteger.withDefault(1));
  const [perPage] = useQueryState('perPage', parseAsInteger.withDefault(10));
  const [sort] = useQueryState(
    'sort',
    getSortingStateParser<PurchasePlanning>().withDefault(defaultSorting),
  );
  const { filtersWithSupplier } = usePurchasePlanningFilters();
  const queryParams = useMemo(
    () => ({
      year,
      week,
      endYear,
      endWeek,
      page,
      perPage,
      sort,
      filters: filtersWithSupplier,
    }),
    [year, week, endYear, endWeek, page, perPage, sort, filtersWithSupplier],
  );
  const deferredParams = useDeferredValue(queryParams);
  const isPending = queryParams !== deferredParams;

  const { data: purchasePlanning } = useGetPurchasePlanning(deferredParams);

  return {
    purchasePlanning,
    isPending,
  };
};
